var _module_exports ="<div class=\"breadcrumbs-wrapper\" gov-breadcrumb></div>";;
var path = '/app/Main/grcEdit/recommendation/recommendationBreadcrumbs.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;